module.exports = __webpack_public_path__ + "img/componter_introduce_bg.21ad66ed.png";